import { Box, Flex } from '@styles/flexBox';
import styled, { css } from 'styled-components';

export const PhotoList = styled(Flex)`
  flex: 1;
  flex-wrap: wrap;
  // justify-content: center;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    display: block;
  }

  ${(props) =>
    props.templateList &&
    css`
      @media (min-width: 768px) {
        margin-left: 0;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.justify &&
    css`
      justify-content: ${props.justyfy};
    `}
`;

export const EmptyPhotoList = styled(Flex)`
  padding: 40px 0;
  width: 100%;
  text-align: center;
  justify-content: center;
`;

export const LookDeleteBoxItem = styled(Box)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 100;
  display: none;

  ${(props) =>
    props.isGallery &&
    css`
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: var(--main-gray);
      opacity: 0.5;
    `}
`;

export const PhotoBox = styled(Box)`
  width: 30%;
  position: relative;
  margin-bottom: 10px;
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  &:hover {
    cursor: pointer;
  }

  &:hover ${LookDeleteBoxItem} {
    display: block;
  }

  @media (min-width: 768px) {
    margin-right: 10px;
    width: 30%;
    height: 0;
    padding-bottom: 30%;

    ${(props) =>
      props.third &&
      css`
        margin-right: 0;
      `}
  }

  @media (min-width: 1200px) {
    width: 30%;
    height: 0;
  }

  @media (max-width: 768px) {
    display: inline-block;
    vertical-align: initial;
    width: 48%;
    margin-right: 3.5%;
    margin-bottom: 3%;
    padding-top: 48%;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 12px;

    &:nth-child(2n + 2) {
      margin-right: 0;
    }
  }

  ${(props) =>
    props.isList &&
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background: transparent;
      color: #0155fa;
      font-weight: bold;
      text-align: center;
      border: 2px dashed rgba(1, 85, 250, 0.3);
      border-radius: 8px;

      @media (min-width: 1200px) {
        padding-bottom: 30%;
      }

      @media (max-width: 768px) {
        display: inline-flex;
        padding-top: 47.5%;
      }

      @media (max-width: 568px) {
        padding-top: 46.5%;
      }

      &:hover {
        background: transparent;
        border-color: #0155fa;
      }

      ${(props) =>
        props.isInsideLook &&
        css`
          margin-right: 0 !important;

          @media (min-width: 1200px) {
            width: 23.6%;
            height: 0;
            padding-bottom: 23.6%;
          }

          ${LookDeleteBoxItem} {
            display: none;
          }

          &:hover ${LookDeleteBoxItem} {
            display: block;
          }
        `}
    `}

  ${(props) =>
    props.uploadPhoto &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: transparent;
      color: #0155fa;
      font-weight: bold;
      text-align: center;
      border: 2px dashed rgba(1, 85, 250, 0.3);
      border-radius: 8px;

      @media (min-width: 1200px) {
        padding-bottom: 30%;
      }

      @media (max-width: 768px) {
        display: inline-flex;
        padding-top: 47.5%;
      }

      @media (max-width: 568px) {
        padding-top: 46.5%;
      }

      &:hover {
        background: transparent;
        border-color: #0155fa;
      }

      ${(props) =>
        props.isInsideLook &&
        css`
          margin-right: 0 !important;

          @media (min-width: 1200px) {
            width: 23.6%;
            height: 0;
            padding-bottom: 23.6%;
          }

          ${LookDeleteBoxItem} {
            display: none;
          }

          &:hover ${LookDeleteBoxItem} {
            display: block;
          }
        `}
    `}

  ${(props) =>
    props.uploadMediaGallery &&
    css`
      position: relative;

      @media (min-width: 1200px) {
        width: 60px;
        height: 60px;
        padding-bottom: 0;
      }

      @media (max-width: 768px) {
        width: 60px;
        height: 60px;
        padding-bottom: 0;
      }

      @media (min-width: 768px) {
        width: 60px;
        height: 60px;
        padding-bottom: 0;
      }
    `}

  ${(props) =>
    props.uploadDigitalImage &&
    css`
      position: relative;

      width: 150px;
      height: 150px;
      padding: 0;

      @media (min-width: 1200px) {
        width: 150px;
        height: 150px;
        padding: 0;
      }

      @media (max-width: 768px) {
        width: 150px;
        height: 150px;
        padding: 0;
      }

      @media (min-width: 768px) {
        width: 150px;
        height: 150px;
        padding: 0;
      }
    `}

  ${(props) =>
    props.uploadTikTok &&
    css`
      position: relative;
      padding-bottom: 54%;
      width: 30.8%;

      @media (min-width: 1200px) {
        padding-bottom: 54%;
      }

      @media (min-width: 768px) {
        padding-bottom: 54%;
        padding-top: 0;
      }

      @media (max-width: 768px) {
        padding-bottom: 54%;
        padding-top: 0;
        margin-right: 10px;
      }
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none !important;
    `}

  ${(props) =>
    props.editBox &&
    css`
      @media (max-width: 768px) {
        width: 45%;
        padding-top: 45%;
        border-radius: 8px;
      }
    `}


  ${(props) =>
    props.isInsideLook &&
    css`
      @media (min-width: 1200px) {
        width: 23.6%;
        height: 0;
        padding-bottom: 23.6%;
      }
    `}


  ${(props) =>
    props.isInstagramList &&
    css`
      overflow: hidden;

      @media (min-width: 1200px) {
        width: 100%;
        padding-bottom: 100%;
      }
    `}

  ${(props) =>
    props.itemGrid &&
    css`
      @media (min-width: 768px) {
        width: 100%;
        padding-bottom: 100%;
      }
    `}

${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}

${(props) =>
    props.aspectRatio &&
    css`
      aspect-ratio: ${props.aspectRatio};
    `}
`;

export const PhotoTitleBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.editBox &&
    css`
      display: none;
    `}
`;

export const PhotoTitle = styled(Box)`
  margin: 25px 0;
  font-size: 28px;
  font-weight: bold;

  @media (max-width: 768px) {
    text-align: center;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PhotoText = styled(Box)`
  text-align: center;
  margin-bottom: 35px;
`;

export const PhotoBoxUploadIcon = styled(Box)`
  position: absolute;
  top: 40px;
  width: 32px;
  height: 32px;

  &:before, &:after {
    position: absolute;
    left: 14px;
    content: ' ';
    height: 65px;
    width: 2.5px;
    background-color: #0155fa;

    @media (max-width: 768px) {
      height: 50px;
      width: 2px;
      left: 25px;
    }
  }

  &:before {
    transform: rotate(0deg);
  }

  &:after {
    transform: rotate(-90deg);
  }

  @media (max-width: 768px) {
    top: 30px;
    height: 50px;
    width: 50px;
  }

  ${(props) =>
    props.uploadMediaGallery &&
    css`
      top: 21px;
      left: 13px;

      &:before,
      &:after {
        height: 14px;
        width: 2.5px;

        @media (max-width: 568px) {
          height: 14px;
          width: 2px;
        }
      }

      @media (max-width: 768px) {
        top: 22px;
        left: 3px;
      }
    `}

  ${(props) =>
    props.uploadDigitalImage &&
    css`
      padding-top: 5px;
      top: initial;
      left: initial;

      @media (max-width: 768px) {
        top: initial;
        left: initial;
      }
    `}


  ${(props) =>
    props.uploadTikTok &&
    css`
      top: 85px;
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      top: 30px;
      width: 30px;
      height: 30px;

      &:before,
      &:after {
        left: 15px;
        height: 50px;
        width: 1.5px;

        @media (max-width: 768px) {
          left: 25px;
        }
      }
    `}

  ${(props) =>
    props.width &&
    css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: ${props.width};
      height: ${props.width};

      &:before,
      &:after {
        width: 2px;
        height: ${props.width};
      }
    `}


}
`;

export const PhotoBoxUploadTitle = styled(Box)`
  position: absolute;
  bottom: 30px;

  @media (max-width: 1200px) {
    font-size: 14px;
    bottom: 22px;
  }

  ${(props) =>
    props.uploadTikTok &&
    css`
      bottom: 125px;
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      bottom: 25px;
      font-size: 12px;
    `}
`;

export const PhotoImg = styled.img`
  display: flex;
  align-self: end;
  max-width: 100%;
  min-height: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;

  @media (min-width: 1200px) {
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;

    ${(props) =>
      props.checked &&
      css`
        border: 3px #17ce17 solid;
        border-radius: 8px;
        opacity: 1;
      `}
  }

  ${(props) =>
    props.isBorder &&
    css`
      border: 1px solid #ebeef1;
      border-radius: 8px;
    `}

  ${(props) =>
    props.checked &&
    css`
      border: 3px #17ce17 solid;
      border-radius: 8px;
      opacity: 1;
    `}



  ${(props) =>
    !props.isEdit &&
    css`
      opacity: 0.5;
      filter: grayscale(100%);
    `}

  ${(props) =>
    props.isInstagramList &&
    css`
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    `}

  ${(props) =>
    props.cover &&
    css`
      object-fit: cover;
    `}


  ${(props) =>
    props.lookProdcut &&
    css`
      position: absolute;
      object-fit: cover;
    `}
`;
